'use client';

import React, { useEffect, useState } from 'react';
import Button from '@/components/atoms/button';
import { Modal, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/navigation';
import { registerVoucher } from '@/services/apis/modules/banner';
import { notify } from '@/utils/funtion';
import dayjs from 'dayjs';
import { ResponsePlans } from '@/interfaces/plans';
import { getListPlans } from '@/services/apis/modules/plans';

function VoucherRegister() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const userData = useSelector((state: any) => state.userData);
  const router = useRouter();
  const [discountValue, setDiscountValue] = useState(290000);

  useEffect(() => {
    handleGetPlans();
  }, []);

  const handleGetPlans = async () => {
    const result: ResponsePlans = await getListPlans();
    const targetItem = result?.data?.find(item => item?.id === "8c3dae0e-ede3-4ab7-9075-d8f3f47d107a");
    if (targetItem) {
      setDiscountValue(targetItem.price);
    } else {
      setDiscountValue(299000);
    }
  };

  const handleRegister = async () => {
    const now = new Date();
    const body = {
      discountValue: discountValue || 299000,
      discountType: 'fixed',
      maxUsage: 1,
      useFrom: dayjs(now).add(7, 'hour').toISOString(),
      useTo: '2025-06-31T17:00:00.000Z',
    };

    try {
      setLoading(true);
      const res = await registerVoucher(body);
      if (res?.status) {
        notify(
          'success',
          'Đăng ký thành công, vui lòng kiểm tra email',
          'top-center',
          7000,
        );
        setLoading(false);
      } else {
        notify(
          'error',
          'Tài khoản của bạn đã được đăng ký trước đây, vui lòng kiểm tra lại',
          'top-center',
          5000,
        );
        setLoading(false);
      }
    } catch (error: any) {
      notify('error', error, 'top-center', 5000);
      setLoading(false);
    }
  };

  return (
    <div className="o-voucher-register">
      <Spin spinning={isLoading}>
        <div
          className="o-voucher-register_text"
          onClick={() => {
            if (userData?.user) {
              handleRegister();
            } else {
              setIsOpen(true);
            }
          }}
        >
          Nhận voucher ngay
        </div>
      </Spin>
      <Modal
        open={isOpen}
        footer={false}
        width={500}
        centered
        closable={true}
        maskClosable={true}
        className="o-voucher-register-modal"
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div className="o-voucher-register-modal_title">
          Vui lòng đăng nhập để nhận voucher
        </div>
        <div className="o-voucher-register-modal_action">
          <Button
            shape="fill"
            ariaLabel="Bắt đầu"
            variant="secondary"
            onClick={() => {
              setIsOpen(false);
              router.push('/xac-thuc-nguoi-dung');
            }}
          >
            Đăng nhập
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default VoucherRegister;
